import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const hintStyle = { fontSize: "0.85rem", color: "#666", marginBottom: "1rem" };
export const pemStyle = { width: "80%", fontFamily: "monospace", fontSize: "0.8rem" };

export const formatDistinguishedName = (name) =>
  typeof name === "string" ? name.split("\n").filter(Boolean).join("  ·  ") : "";

export const formatExpiry = (validTo) => {
  const expiresOn = new Date(validTo);
  if (!validTo || Number.isNaN(expiresOn.getTime())) return "";
  const days = Math.round((expiresOn.getTime() - Date.now()) / 86400000);
  const formatted = expiresOn.toLocaleDateString();
  if (days < 0) return `expired on ${formatted}`;
  return `expires ${formatted} (${days} days)`;
};

/** A stored certificate is public material, so it can be revealed on request. */
export function StoredCertificate({ label, pem, metadata, description }) {
  const [visible, setVisible] = useState(false);
  const expiry = formatExpiry(metadata?.validTo);

  return (
    <div style={{ marginBottom: "1rem" }}>
      <label className="searchSelectLabel">{label}</label>
      {pem && (
        <IconButton
          aria-label={visible ? "Hide certificate" : "Show certificate"}
          onClick={() => setVisible((shown) => !shown)}
          size="small"
          style={{ marginLeft: "0.25rem" }}
        >
          {visible ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      )}
      {visible && pem && (
        <pre style={{ ...pemStyle, whiteSpace: "pre-wrap", marginTop: "0.5rem" }}>{pem}</pre>
      )}
      {metadata && (
        <div style={hintStyle}>
          {formatDistinguishedName(metadata.subject)}
          {expiry ? `  ·  ${expiry}` : ""}
        </div>
      )}
      {description && <div style={hintStyle}>{description}</div>}
    </div>
  );
}
